import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Icon from 'components/commons/icon/Icon';

export type PointItem = {
  index: number;
  type: number;
  message: string;
  show: boolean;
};

type PointToastProps = {
  item: PointItem;
  positionVertical: number;
  onClose: (item: PointItem | undefined) => void;
};

const PointToast: React.FC<PointToastProps> = props => {
  const { item, positionVertical, onClose } = props;
  const [fadeMode, setFadeMode] = useState('hidden');
  const history = useHistory();

  const onToastClose = (): void => {
    setFadeMode('ui-effect-fade-out-300');
    onClose(item);
  };

  const gotoPoint = (): void => {
    onClose(undefined);
    history.push('/point');
  };

  useEffect(() => {
    setFadeMode('ui-effect-fade-in-300');
  }, []);

  const icon_name =
    item.type === 1 ? 'check_circle' : item.type === 2 ? 'gift' : 'info';

  return (
    <div className={`${fadeMode} ${!item.show && 'hidden'}`}>
      <div
        className="flex justify-end z-50 absolute"
        style={{ bottom: `${positionVertical}px`, right: '0px' }}>
        <div className="bg-link rounded text-white">
          <div className="flex h-4 mt-1 mr-2">
            <div className="flex-grow"></div>
            <div onClick={onToastClose}>
              <Icon className="text-gray-300 text-sm" name="close" />
            </div>
          </div>
          <div className="flex items-center flex-grow mx-3 mb-2">
            <Icon className="text-3xl" name={icon_name} />
            <div className="text-2xs ml-3">
              <div>
                {item.message.split('\r\n').map((value, index) => {
                  return <p key={index}>{value}</p>;
                })}
              </div>
            </div>
            <div className="w-6" />
          </div>

          <div className="border-t border-gray-300 border-solid" />
          <div className="flex justify-center text-2xs m-2" onClick={gotoPoint}>
            ポイントページへ
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointToast;
